import { select } from 'd3-selection'

export default {
  name: 'my-table',
  template: `
    <div class="o-table" @click="hasFocus(true)" tabindex="-1">
      <transition name="quick-fade">
        <div class="o-table__cover" v-if="$store.state.windowWidth < 608 && coverShown">
          <div class="o-table__cover__icon"><svg class="icon icon-swipe"><use xlink:href="#icon-swipe"></use></svg><span class="u-hide">Swipe</span></div>
        </div>
      </transition>
      <div class="o-table__inner" ref="table" @touchstart="hasFocus(true)"></div>
    </div>
  `,
  props: {
    tableData: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      coverShown: true
    }
  },
  methods: {
    renderTable () {
      let table = select(this.$refs.table).append('table')
        .attr('class', 'o-table--data')
      let thead = table.append('thead')
      let tbody = table.append('tbody')

      // append the header row
      thead.append('tr')
        .selectAll('th')
        .data(this.tableData.data.columns).enter()
        .append('th')
        .text(function (column) { return column })

      // create a row for each object in the data
      let rows = tbody.selectAll('tr')
        .data(this.tableData.data)
        .enter()
        .append('tr')

      // create a cell in each row for each column
      rows.selectAll('td')
        .data((row) => {
          return this.tableData.data.columns.map(function (column) {
            return { column: column, value: row[column] }
          })
        })
        .enter()
        .append(function (d, i) {
          let elem = (i === 0) ? 'th' : 'td'
          return document.createElement(elem)
        })
        .html(function (d, i) {
          return d.value
        })
    },
    hasFocus (bool = false) {
      this.coverShown = !bool
    }
  },
  mounted () {
    this.renderTable()
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-table.js